import React from "react";
import { withTheme } from "styled-components/native";
import { Container } from "../layout/common";
import Button from "../button/Button";
import ConfirmButton from "../button/ConfirmButton";
import { SecuredComponent } from "cci-logic";

/**
 * Container that shows a delete icon on the bottom right of the specified child.
 *
 * Props:
 * - allowDelete: Indicates if the delete icon should be shown or not.
 * - onPress: Function to call when the delete icon is pressed.
 * - checkPermissions: Indicates the permissions that the current user must have to be able to delete the item.
 */
const DeletableItem = ({
  theme,
  allowDelete,
  onPress,
  children,
  checkPermissions,
  iconName,
  confirmMessage,
  onConfirm,
  buttonStyle = {},
  ...props
}) => {
  const ButtonWrapper = confirmMessage ? ConfirmButton : Button;
  return (
    <Container {...props}>
      {children}

      {allowDelete && (
        <SecuredComponent checkPermissions={checkPermissions}>
          <ButtonWrapper
            ui="dangerLink"
            leftIcon={iconName || theme.deleteIconName || "minus-circle"}
            leftIconWeight={900}
            onPress={onPress}
            style={{ position: "absolute", right: 0, bottom: 0, ...buttonStyle }}
            message={confirmMessage}
            onConfirm={onConfirm}
          />
        </SecuredComponent>
      )}
    </Container>
  );
};

export default withTheme(DeletableItem);
